export default __webpack_public_path__ + "static/media/green2.a724f9de.svg";